import React, { useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { ListItemButton, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { getMyProfile } from '../../../api/profileService';
import EditIcon from '@mui/icons-material/Edit';
import ProfileInfoForm from '../forms/ProfileInfoForm';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChangePasswordForm from '../forms/ChangePasswordForm';
import ConfirmDialog from '../../common/modals/ConfirmDialog';

export default function ProfileInfo() {
    const [open, setOpen] = React.useState(false);

    const [formOpen, setFormOpen] = React.useState(false);
    const [passwordFormOpen, setPasswordFormOpen] = React.useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const [profile, setProfile] = useState(null);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const fetchProfile = async () => {
      const profile = await getMyProfile();
      setProfile(profile);
    }

    const handleEditClick = () => {
      setFormOpen(true);
    };

    const onUpdateSuccess = () => {
      fetchProfile();
    };

    useEffect(() => {
      if (open)
      {
        fetchProfile();
      }
    }, [open]);

    return (
        <React.Fragment>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <AccountCircleIcon fontSize='large' color='secondary'/>
            </ListItemIcon>
            <ListItemText 
                primary="Profile Information"
                secondary="view and edit your profile information"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
              Profile Information
            </DialogTitle>
            <DialogContent>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Name</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{profile?.name || "(none)"}</Typography>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>E-mail</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{profile?.email || "(none)"}</Typography>
              
              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Professional Name (used in prescriptions and forms templates)</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{profile?.professional_name || "(none)"}</Typography>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>License Number</Typography>
              <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{profile?.license_number || "(none)"}</Typography>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>PTR Number</Typography>
              <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{profile?.ptr_number || "(none)"}</Typography>
              
              <br />
              <Button fullWidth variant='outlined' onClick={() => {setConfirmDialogOpen(true)}}>Change Password</Button>

            </DialogContent>
            <DialogActions>
              <Button onClick={handleEditClick}>
                  <EditIcon />
              </Button>
              <div style={{flex: '1 0 0'}} />
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <ProfileInfoForm
          profile={profile}
          successCallback={onUpdateSuccess}
          open={formOpen}
          onClose={() => setFormOpen(false)}
        />
        <ChangePasswordForm 
          open={passwordFormOpen}
          onClose={() => setPasswordFormOpen(false)}
        />
        <ConfirmDialog
          open={confirmDialogOpen}
          title="Change Password"
          content="Are you sure you want to change your password? You will be automatically logged off after a successful password change."
          confirmText="Proceed"
          cancelText="Cancel"
          onConfirm={() => {
            setPasswordFormOpen(true);
            setConfirmDialogOpen(false);
          }}
          onCancel={() => setConfirmDialogOpen(false)}
      />
        </React.Fragment>
    );
}